import React from "react";
import { useHistory } from "react-router-dom";
import { PreviewAltCard, Icon } from "../../Component";

const TrendCard = ({ title, value, change, period, trend, icon, color, link, loading, onClick }) => {
  const history = useHistory();
  const trendColor = trend === "up" ? "text-success" : trend === "down" ? "text-danger" : "";
  const trendIcon = trend === "up" ? "arrow-long-up" : trend === "down" ? "arrow-long-down" : "";
  const displayChange = change !== undefined && change !== null;

  return (
    <PreviewAltCard 
      className={`card-bordered h-100 ${link || onClick ? "card-clickable" : ""}`}
      onClick={() => {
        if (onClick) onClick();
        else if (link) history.push(link);
      }}
    >
      <div className="card-title-group mb-3">
        <div className="card-title d-flex align-items-center">
          <Icon name={icon} className="text-soft me-3"></Icon>
          <h6 className="title mb-0">{title}</h6>
        </div>
      </div>
      <div className="card-amount">
        <span className="amount">
          {loading ? (
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            typeof value === "number" ? value.toLocaleString() : value
          )}
        </span>
        {displayChange && (
          <span className={`change ${trend === "up" ? "up" : "down"} ${trendColor}`}>
            {trendIcon && <Icon name={trendIcon}></Icon>}
            {change > 0 ? "+" : ""}{change}%
          </span>
        )}
      </div>
    </PreviewAltCard>
  );
};

export default TrendCard;
